import { httpService } from "./httpService";

/**
 * Outbox admin endpoints. Tenant-scoped; surfaces the dispatcher's recent
 * events with retry counts, last errors, and a manual retry button.
 */

export const getOutboxEvents = async (status) => {
  const q = status ? `?status=${encodeURIComponent(status)}` : "";
  return httpService({ url: `/outbox/events${q}`, options: { method: "GET" } });
};

export const retryOutboxEvent = async (eventId) =>
  httpService({ url: `/outbox/events/${eventId}/retry`, options: { method: "POST" } });

/** At-a-glance counts for the page header (pending / processed-24h / failed-24h / oldest pending age). */
export const getOutboxHealth = async () =>
  httpService({ url: "/outbox/health", options: { method: "GET" } });

/** Per-type counts in the last 24h, sorted failed-first. */
export const getOutboxTypeStats = async () =>
  httpService({ url: "/outbox/type-stats", options: { method: "GET" } });

/** Pause the dispatcher (incident-response kill switch; process-local). */
export const pauseOutboxDispatcher = async () =>
  httpService({ url: "/outbox/pause", options: { method: "POST" } });

/** Resume the dispatcher. */
export const resumeOutboxDispatcher = async () =>
  httpService({ url: "/outbox/resume", options: { method: "POST" } });
